<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	fill="none"
	viewBox="0 0 48 48"
	{height}
	{width}
	class={className}
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M39 19C39.0014 16.2739 38.2599 13.599 36.8551 11.2627C35.4504 8.92638 33.4355 7.01708 31.027 5.73999C28.6186 4.46289 25.9076 3.8663 23.1855 4.01432C20.4635 4.16234 17.8332 5.04939 15.5774 6.58011C13.3216 8.11084 11.5256 10.2274 10.3825 12.7022C9.23937 15.1771 8.79228 17.9167 9.08931 20.6265C9.38633 23.3364 10.4162 25.9141 12.0683 28.0826C13.7204 30.251 15.9322 31.9283 18.466 32.934L24 44L29.534 32.934C32.3254 31.826 34.72 29.9056 36.4077 27.4213C38.0954 24.937 38.9984 22.0033 39 19ZM24 13C25.1867 13 26.3467 13.3519 27.3334 14.0112C28.3201 14.6705 29.0892 15.6076 29.5433 16.7039C29.9974 17.8003 30.1162 19.0067 29.8847 20.1706C29.6532 21.3345 29.0818 22.4036 28.2426 23.2427C27.4035 24.0818 26.3344 24.6532 25.1705 24.8847C24.0067 25.1163 22.8003 24.9974 21.7039 24.5433C20.6075 24.0892 19.6705 23.3201 19.0112 22.3335C18.3519 21.3468 18 20.1867 18 19C18 17.4087 18.6321 15.8826 19.7574 14.7574C20.8826 13.6322 22.4087 13 24 13Z"
		fill="currentColor"
	/>
	<path
		d="M24 13C25.1867 13 26.3467 13.3519 27.3334 14.0112C28.3201 14.6705 29.0892 15.6076 29.5433 16.7039C29.9974 17.8003 30.1162 19.0067 29.8847 20.1706C29.6532 21.3345 29.0818 22.4036 28.2426 23.2427C27.4035 24.0818 26.3344 24.6532 25.1705 24.8847C24.0067 25.1163 22.8003 24.9974 21.7039 24.5433C20.6075 24.0892 19.6705 23.3201 19.0112 22.3335C18.3519 21.3468 18 20.1867 18 19C18 17.4087 18.6321 15.8826 19.7574 14.7574C20.8826 13.6322 22.4087 13 24 13Z"
		fill="white"
	/>
</svg>
